import apiClient from "../utils/axiosPetition";

/**
 * Servicio para manejar operaciones de membresía
 */
export const membershipService = {
  /**
   * Obtener estado actual de membresía del usuario
   * Incluye información del usuario y estado de membresía
   */
  async getMembershipStatus() {
    try {
      const response = await apiClient.get('/api/membership/status');
      return {
        ok: true,
        data: response.data
      };
    } catch (error) {
      return {
        ok: false,
        error: error.response?.data?.message || 'Error al obtener estado de membresía'
      };
    }
  },

  /**
   * Obtener planes disponibles
   */
  async getAvailablePlans() {
    try {
      const response = await apiClient.get('/api/membership/plans');
      return {
        ok: true,
        data: response.data
      };
    } catch (error) {
      return {
        ok: false,
        error: error.response?.data?.message || 'Error al obtener planes disponibles'
      };
    }
  },

  /**
   * Actualizar plan de membresía
   */
  async updateMembership(planId) {
    try {
      const response = await apiClient.post('/api/membership/update', { planId });
      return {
        ok: true,
        data: response.data
      };
    } catch (error) {
      return {
        ok: false,
        error: error.response?.data?.message || 'Error al actualizar membresía'
      };
    }
  },

  /**
   * Obtener precio del upgrade a premium
   */
  async getUpgradePrice() {
    try {
      const response = await apiClient.get('/api/precios/upgrade');
      return {
        ok: true,
        data: response.data
      };
    } catch (error) {
      return {
        ok: false,
        error: error.response?.data?.message || 'Error al obtener precio de upgrade'
      };
    }
  },

  /**
   * Iniciar proceso de upgrade a premium
   * Usa el endpoint unificado de procesar-pago con tipo: 'membresia' y userId
   */
  async initiateUpgrade(userId, amount = null) {
    try {
      const response = await apiClient.post('/api/epayco/procesar-pago', {
        tipo: 'membresia',
        userId,
        amount
      });
      return {
        ok: true,
        data: response.data
      };
    } catch (error) {
      return {
        ok: false,
        error: error.response?.data?.message || 'Error al iniciar upgrade a premium'
      };
    }
  },

  /**
   * Cancelar membresía premium
   */
  async cancelPremium() {
    try {
      const response = await apiClient.post('/api/membership/cancel');
      return {
        ok: true,
        data: response.data
      };
    } catch (error) {
      return {
        ok: false,
        error: error.response?.data?.message || 'Error al cancelar membresía'
      };
    }
  },

  /**
   * Obtener historial de transacciones
   */
  async getTransactionHistory() {
    try {
      const response = await apiClient.get('/api/membership/transactions');
      return {
        ok: true,
        data: response.data
      };
    } catch (error) {
      return {
        ok: false,
        error: error.response?.data?.message || 'Error al obtener historial'
      };
    }
  },

  /**
   * Verificar acceso a una característica específica
   */
  async checkFeatureAccess(featureName) {
    try {
      const response = await apiClient.post('/api/membership/check-feature', { featureName });
      return {
        ok: true,
        data: response.data
      };
    } catch (error) {
      return {
        ok: false,
        error: error.response?.data?.message || 'Error al verificar acceso'
      };
    }
  },

  /**
   * Migrar usuario individual a sistema de membresía
   */
  async migrateUser(userId) {
    try {
      const response = await apiClient.post('/api/membership/migrate-user', { userId });
      return {
        ok: true,
        data: response.data
      };
    } catch (error) {
      return {
        ok: false,
        error: error.response?.data?.message || 'Error al migrar usuario'
      };
    }
  },

  /**
   * Obtener estadísticas de migración
   */
  async getMigrationStats() {
    try {
      const response = await apiClient.get('/api/membership/migration-stats');
      return {
        ok: true,
        data: response.data
      };
    } catch (error) {
      return {
        ok: false,
        error: error.response?.data?.message || 'Error al obtener estadísticas de migración'
      };
    }
  }
};

export default membershipService; 